import { FormattedMessage } from 'react-intl';
import {
  RescheduleModalContainer,
  BookingUpdatedContainer,
  BookingUpdatedHeader,
  BookingUpdatedMessage,
  UpdatedMessage,
  ConfirmButtonRow,
  ConfirmButton,
} from '../styles';
import type { BookingUpdatedProps } from '../types';

export const BookingUpdated = ({ booking, onClose }: BookingUpdatedProps) => {
  return (
    <RescheduleModalContainer data-testid="reschedule-modal-booking-updated">
      <BookingUpdatedContainer>
        <BookingUpdatedHeader>
          <FormattedMessage defaultMessage="Booking Updated!" />
        </BookingUpdatedHeader>
        <BookingUpdatedMessage>
          <UpdatedMessage>
            <FormattedMessage defaultMessage="Your booking has been successfully updated." />
          </UpdatedMessage>

          {booking.guestEmail ? (
            <FormattedMessage
              defaultMessage="We've also sent an email with the updated tickets to you at {email}"
              values={{ email: booking.guestEmail }}
            />
          ) : (
            <FormattedMessage defaultMessage="Your booking has been successfully updated. We've also sent an email with the updated tickets." />
          )}
        </BookingUpdatedMessage>
        <ConfirmButtonRow>
          <ConfirmButton
            data-testid="booking-updated-okay-button"
            onClick={() => {
              onClose({ afterSuccess: true });
            }}
          >
            <FormattedMessage id="OKAY" defaultMessage="Okay" />
          </ConfirmButton>
        </ConfirmButtonRow>
      </BookingUpdatedContainer>
    </RescheduleModalContainer>
  );
};
